import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '../store'

import i18n from '../i18n'
import Home from "@/components/Home.vue";
import { tokenIsValid, checkUserByRole, SESSION_TOKEN_KEY, tokenLocalStorgeIsValid } from "@/utils";
import { HomePageRoles, MenuRoles } from "@/types";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/login_no_sso',
        name: 'login_no_sso',
        meta: {
            role: "all",
            userRequired: false
        },
        component: () => import('@/components/auth/Login.vue')
    },
    {
        path: '/',
        meta: {
            role: "all",
            userRequired: false
        },
        component: () => import('@/components/auth/Login.vue')
    },
    {
        path: '/home',
        name: 'home',
        meta: {
            role: "all",
            userRequired: true
        },
        component: Home
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            role: "all",
            userRequired: false
        },
        component: () => import('@/components/auth/Login.vue')
    },
    {
        path: '/oidc-callback',
        name: 'oidc-callback',
        meta: {
            role: "all",
            userRequired: false
        },
        component: () => import('@/views/OidcCallback.vue')
    },
    {
        path: '/signup',
        name: 'signup',
        meta: {
            role: "all",
            userRequired: false
        },
        component: () => import('@/components/auth/Registration.vue')
    },
    {
        path: '/forgotPassword',
        name: 'forgotPassword',
        meta: {
            role: "all",
            userRequired: false
        },
        component: () => import('@/components/auth/ForgotPassword.vue')
    },
    {
        path: '/demand/list',
        name: 'demand-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/demand/DemandViewList.vue')
    },
    {
        path: '/demand/edit/:id?',
        name: 'demand-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/demand/DemandViewEdit.vue')
    },
    {
        path: '/order/edit/:id?',
        name: 'order-edit',
        meta: {
            role: 'all',
            userRequired: true
        },
        component: () => import('@/views/order/OrderViewEdit.vue')
    },
    {
        path: '/mo/demand/detail/:id?',
        name: 'mo-demand-detail',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/middle-office/MiddleOfficeView.vue')
    },
    {
        path: "/order",
        name: "order",
        meta: {
            role: 'all',
            userRequired: true
        },
        component: () => import("@/views/order/OrderViewList.vue")
    },
    {
        path: '/third/list',
        name: 'third-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/party/ThirdViewList.vue')
    },
    {
        path: '/third/edit/:id?',
        name: 'third-edit',
        meta: {
            role: 'all',
            userRequired: true
        },
        component: () => import('@/views/party/ThirdViewEdit.vue')
    },
    {
        path: '/task/list',
        name: 'task-list',
        meta: {
            role: 'all',
            userRequired: true
        },
        component: () => import('@/views/tasks/TaskViewList.vue')
    },
    {
        path: '/vault/history',
        name: 'vault-history',
        meta: {
            role: 'all',
            userRequired: true
        },
        component: () => import('@/views/document/VaultHistoryView.vue')
    },
    {
        path: '/vault/orders',
        name: 'vault-orders',
        meta: {
            role: 'all',
            userRequired: true
        },
        component: () => import('@/views/document/VaultOrdersView.vue')
    },
    {
        path: '/task/detail',
        name: 'TaskDetail',
        meta: {
            role: 'all',
            userRequired: true
        },
        component: () => import('@/views/tasks/TaskView.vue')
    },
    {
        path: '/scale/list',
        name: 'scale-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/scales/ScaleViewList.vue')
    },
    {
        path: '/scale/edit',
        name: 'scale-edit',
        meta: {
            role: MenuRoles.ROLE_MENU_SCALE,
            userRequired: true
        },
        component: () => import('@/views/configuration/scales/ScaleViewDetails.vue')
    },
    {
        path: '/profile',
        name: 'Profile',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/user-preference/ProfileView.vue')
    }, {
        path: '/garanty/list',
        name: 'garanty-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/garanty/GuaranteeView.vue')
    },
    {
        path: '/good/list',
        name: 'asset-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/goods/GoodViewList.vue')
    },
    {
        path: '/documentType/list',
        name: 'documentType-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/documents/documentTypeViewList.vue')
    },
    {
        path: '/documentType/edit/:id?',
        name: 'documentType-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/documents/documentTypeViewEdit.vue'),
        props: true
    },
    {
        path: '/documentFamily/edit',
        name: 'documentFamily-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/documents/documentDetailsView.vue')
    },
    {
        path: '/documentFamily/list',
        name: 'documentFamily-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/documents/documentFamilyViewList.vue')
    },
    {
        path: '/action/list',
        name: 'action-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/actions/ActionsViewList.vue')
    },
    {
        path: '/action/edit',
        name: 'action-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/actions/ActionViewDetails.vue')
    },
    {
        path: '/actionContext/list',
        name: 'actionContext-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/actions/ActionsContextViewList.vue')
    },
    {
        path: '/userAdmin/list',
        name: 'user-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/UserViewList.vue')
    },
    {
        path: '/userAdmin/edit',
        name: 'user-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/UserViewDetails.vue'),
    },
    {
        path: '/good/edit',
        name: 'good-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/goods/GoodViewDetails.vue')
    }, {
        path: '/rule',
        name: 'rule',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/rule.vue')
    },
    {
        path: '/availability/list',
        name: 'availability-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/availabilities/AvailabilityViewList.vue')
    },
    {
        path: '/aides/list',
        name: 'aides-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/aides/AideViewList.vue')
    },
    {
        path: '/opinion/detail',
        name: 'OpinionDetail',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/tasks/OpinionView.vue')
    },
    {
        path: '/analysis/detail',
        name: 'AnalysisDetail',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/middle-office/AnalysisView.vue')
    },
    {
        path: '/changePassword',
        name: 'changePassword',
        meta: {
            role: "all",
            userRequired: false
        },
        component: () => import('@/components/auth/ChangePassword.vue')
    },
    {
        path: '/role-menu',
        name: 'ScreenAuthority',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/role-menu/RoleMenuViewList.vue')
    },
    {
        path: '/deliverySchedule',
        name: 'deliverySchedule',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/deliverySchedule/DeliveryScheduleView.vue')
    },
    {
        path: '/delegation/list',
        name: 'delegation-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/delegation/DelegationViewList.vue')
    },
    {
        path: '/delegation/edit',
        name: 'delegation-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/delegation/DelegationViewDetails.vue')
    },
    {
        path: '/objective/list',
        name: 'objective-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/objective/definition/ObjectiveViewList.vue')
    },
    {
        path: '/objectiveSales/list',
        name: 'objectiveSales-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/objective/sales/ObjectiveSalesViewList.vue')
    },
    {
        path: '/objective/gestion',
        name: 'objective-gestion',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/objective/gestion/GestionView.vue')
    },
    {
        path: '/objective/edit',
        name: 'objective-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/objective/definition/ObjectiveViewDetails.vue')
    },
    {
        path: '/GestionDabsence',
        name: 'GestionDabsence',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/AbsenceManagement.vue')
    },
    {
        path: '/GestionDabsence/edit',
        name: 'GestionDabsenceEdit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/AbsenceManagementViewDetails.vue')
    },
    {
        path: '/group/list',
        name: 'group-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/GroupViewList.vue')
    },
    {
        path: '/team/list',
        name: 'team-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/TeamViewList.vue')
    },
    {
        path: '/network/list',
        name: 'network-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/NetworkViewList.vue')
    },
    {
        path: '/group/edit',
        name: 'group-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/GroupViewDetail.vue')
    },
    {
        path: '/team/edit',
        name: 'team-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/TeamViewDetail.vue')
    },
    {
        path: '/network/edit',
        name: 'network-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/NetworkViewDetail.vue')
    },
    {
        path: '/authority/list',
        name: 'authority-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/AuthorityViewList.vue')
    },
    {
        path: '/daaq/list',
        name: 'daaq-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/DaaqViewList.vue')
    },
    {
        path: '/daaq/edit',
        name: 'daaq-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/users/DaaqViewDetail.vue')
    },
    {
        path: '/actionContext/edit',
        name: 'actionContext-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/actions/ActionContextDetail.vue')
    },
    {
        path: '/404',
        name: 'Page404',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/404.vue')
    },
    {
        path: '/remuneration/list',
        name: 'remuneration-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/remuneration/RemunerationViewList.vue')
    },
    {
        path: '/remuneration/edit',
        name: 'remuneration-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/remuneration/RemunerationViewDetail.vue')
    },
    {
        path: '/configuration/signatureTemplate',
        name: 'signatureTemplate-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/esign/SignatureTemplateViewList.vue')
    },
    {
        path: '/configuration/signatureTemplate/:id',
        name: 'signatureTemplate-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/esign/SignatureTemplateViewDetails.vue'),
        props: true
    },
    {
        path: '/configuration/emailConfig',
        name: 'emailConfig-list',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/esign/EmailConfigViewList.vue')
    },
    {
        path: '/configuration/emailConfig/:id',
        name: 'emailConfig-edit',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/esign/EmailConfigViewDetails.vue'),
        props: true
    } ,
    {
        // Paramétrage MiSIV : réservé au rôle administrateur, comme l'API qui le sert.
        path: '/configuration/misiv',
        name: 'misiv-settings',
        meta: {
            role: 'ROLE_ADMIN',
            userRequired: true
        },
        component: () => import('@/views/configuration/misiv/MisivSettingsView.vue')
    },
    {
        // Boîtes mail entrantes CoreDI : administrateur + feature flag MAIL_INBOUND (vérifié par la vue).
        path: '/configuration/mail-inbound',
        name: 'mail-inbound-settings',
        meta: {
            role: 'ROLE_ADMIN',
            userRequired: true
        },
        component: () => import('@/views/configuration/mailInbound/MailInboundSettingsView.vue')
    },
    {
        // Configuration > Général : prise des rendez-vous planning livraison.
        path: '/configuration/general',
        name: 'general-settings',
        meta: {
            role: "all",
            userRequired: true
        },
        component: () => import('@/views/configuration/general/GeneralSettingsView.vue')
    },
    {
        // Whitelist des destinataires : environnements de test, l'écran vérifie le flag RECIPIENT_WHITELIST.
        path: '/configuration/recipient-whitelist',
        name: 'recipient-whitelist',
        meta: {
            role: 'ROLE_ADMIN',
            userRequired: true
        },
        component: () => import('@/views/configuration/recipientWhitelist/RecipientWhitelistView.vue')
    },
    {
      path: "/external/document-upload/:token",
      name: "external-document-upload",
      meta: {
        role: "all",
        userRequired: false,
        hideLayout: true,
      },
      component: () =>
        import("@/views/external/ExternalDocumentUpload.vue"),
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// Gestion des erreurs de chunk de Vue Router
router.onError(error => {
    console.error(error);

    if (/ChunkLoadError:.*failed./i.test(error.message)) {
        console.error('Reloading Window 1');
        window.location.reload();
    } else if (/Loading.*chunk.*failed./i.test(error.message)) {
        console.error('Reloading Window 2');
        window.location.reload();
    }
});

router.beforeEach((to, from, next) => {
    const browserPath = window.location.pathname;
    const isAuthenticated = tokenLocalStorgeIsValid();

    if (browserPath === '/login_no_sso' && !isAuthenticated) {
        if (to.path !== '/login_no_sso') {
            next('/login_no_sso');
            return;
        }
        next();
        return;
    }

    if (to.path == '/oidc-callback' || to.path == '/login_no_sso') {
        next();
        return;
    }

    if (to.meta.role === "all" || checkUserByRole([to.meta.role])) {
        if (!to.path.includes('task')) {
            store.dispatch('taskModule/setFilterByOfferReference', '')
        }
        if (to.path.search("demand") > 0) {
            store.dispatch("module", "demand");
        } else if (to.path.search("third") > 0) {
            store.dispatch("module", "third");
        } else if (to.path.search("task") > 0) {
            store.dispatch("module", "task");
        }
        else if (to.path.search("good") > 0) {
            store.dispatch("module", "asset");
        }
        else if (to.path.search("order") > 0) {
            store.dispatch("module", "dossier");
        }
        else if (to.path.search("GestionDabsence") > 0) {
            store.dispatch("module", "GestionDabsence");
        }
        else if (to.path.search("deliverySchedule") > 0) {
            store.dispatch("module", "deliverySchedule");
        }
        else if (to.path.search("documentType") > 0) {
            store.dispatch("module", "documentType");
        }
        else if (to.path.search("documentFamily") > 0) {
            store.dispatch("module", "documentFamily");
        }
        else if (to.path.search("availability") > 0) {
            store.dispatch("module", "availability");
        }
        else if (to.path.search("remuneration") > 0) {
            store.dispatch("module", "remuneration");
        }
        else if (to.path.search("action/") > 0) {
            store.dispatch("module", "action");
        }
        else if (to.path.search("actionContext") > 0) {
            store.dispatch("module", "actionContext");
        }
        else if (to.path.search("objective/") > 0 && !to.path.includes("objective/gestion")) {
            store.dispatch("module", "objectiveDefinition");
        }
        else if (to.path.search("objectiveSales") > 0) {
            store.dispatch("module", "objectiveSales");
        }
        else if (to.path.search("objective/gestion") > 0) {
            store.dispatch("module", "objectiveRestitution");
        }
        else if (to.path.search("role-menu") > 0) {
            store.dispatch("module", "roleMenu");
        }
        else if (to.path.search("signatureTemplate") > 0) {
            store.dispatch("module", "signatureTemplate");
        }
        else if (to.path.search("emailConfig") > 0) {
            store.dispatch("module", "emailConfig");
        }
        else if (to.path.search("delegation") > 0) {
            store.dispatch("module", "delegation");
        }
        else if (to.path.search("authority") > 0) {
            store.dispatch("module", "Authority");
        }
        else if (to.path.search("network") > 0) {
            store.dispatch("module", "network");
        }
        else if (to.path.search("team") > 0) {
            store.dispatch("module", "team");
        }
        else if (to.path.search("group") > 0) {
            store.dispatch("module", "group");
        }
        else if (to.path.search("userAdmin") > 0) {
            store.dispatch("module", "userAdmin");
        }
        else {
            store.dispatch("module", "home");
        }
        if (((to.path !== '/' &&
            to.path !== '/login' &&
            to.path !== '/login_no_sso' &&
            to.path !== '/signup' &&
            to.path !== '/forgotPassword' &&
            !to.path.startsWith("/external/")
        ) && !tokenLocalStorgeIsValid())) {
            next('/login')
        }
        else if ((to.path === '/login' ||
            to.path === '/login_no_sso' ||
            to.path === '/signup' ||
            to.path === '/forgotPassword') && (tokenLocalStorgeIsValid())) {

            const homePageRolesKeys = Object.keys(HomePageRoles); // Get an array of all HomePageRoles enum keys
            homePageRolesKeys.forEach((key: any) => {
                const role: any = key; // Get the enum key
                const value: any = (HomePageRoles as any)[key]
                if (checkUserByRole([key])) {
                    next('/' + value); // Use the value for redirection
                    return
                }
            });


        }
        else if (to.path === '/changePassword' && tokenIsValid()) {
            store.commit('authModule/setChangePassWordIn', false)
            next()
        }
        else {
            const lock = store.state.lockState
            if (lock) {
                store.state.authModule!.user.loggedIn = true
                store.dispatch("showConfirmationDialog", {
                    message: i18n.global.t('main.confirmationDialog.message'),
                    target: to.fullPath
                });
                next(false)
            } else {
                next()
            }
        }
    }
    else {
        next('/404');
    }
})

export default router
